"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPresetColor = isPresetColor;

var _colors = require("../_util/colors");

// eslint-disable-next-line import/prefer-default-export
function isPresetColor(color) {
  return _colors.PresetColorTypes.indexOf(color) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/badge/utils.js
// module id = 208
// module chunks = 0